import axios, { Method, ResponseType } from 'axios';
import fileDownload from 'js-file-download';
import { JsonObj } from '@mhp/general-interface';
import Logger from './Logger';
import { getFileDownloadDestinations, getMimeType } from './FileServices.common';

const download = async (
  filename: string,
  url: string,
  headers: JsonObj = {},
  mimeType?: string,
  method: Method = 'GET',
  body?: object,
  responseType: ResponseType = 'blob',
  isMonoRepo?: boolean
) => {
  try {
    const { data: axiosData } = await axios(`${url}`, {
      method,
      data: body,
      headers,
      responseType
    });
    const { fileDestinations } = getFileDownloadDestinations(filename, mimeType);

    const data = isMonoRepo ? axiosData.data : axiosData;

    for await (const destination of fileDestinations) {
      fileDownload(data, destination);
    }
  } catch (err) {
    Logger.error('FileServices: Failed to download file', { filename, url });

    throw err;
  }
};

const FileServices = {
  getMimeType,
  download
};

export default FileServices;
